import { useMemo } from 'react';

import { useIsArticleViewEnabled } from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useArticlePageSettings: UseMainUIFeatureSettings<'articlePage'> = (options) => {
  const articlePageOverrides = options?.overrides?.articlePage;
  const isArticlePageEnabled = useIsArticleViewEnabled();

  return useMemo(
    () => ({
      [uiFeatureAccessSymbol]: isArticlePageEnabled,
      isArticlePageEnabled,
      ...articlePageOverrides,
    }),
    [isArticlePageEnabled, articlePageOverrides]
  );
};
